<template>


  <v-form ref="form" v-model="valid"  >
    <v-container>
      <div style="text-align: right;margin: 20px "> 
         V {{versio}}
      </div>
      <!--div>
        <v-btn color="error" @click="test" :disabled="!ready">
          test
        </v-btn>
      </div-->
      
      <div style="margin: 10px;padding: 30px;text-align:center">
        <p>
          Descargue la hoja covid para cumplimentar. El administrador podrá firmarla con firma electrónica, o con firma manuscrita y escanearla despues como pdf. Una vez firmada podrá enviarse desde esta página.
        </p>
        
        <p>
          Descarregui el full covid per emplenar. L'administrador podrà signar-la amb signatura electrònica, o signatura manuscrita i escanejar-la després com pdf. Una vegada signat, podra enviar-se desde aquesta pàgina.
        </p>
        <v-btn color="green"
          class="ma-2" 
          outlined 
          href="./hoja covid rellenable.pdf"
          download>
          Descargar Hoja covid<br/>
          Descarregar Full covid
        </v-btn>
        </div>

      <div style="border: solid;margin: 10px;padding: 30px">
      <v-row>
        <v-col
          cols="12"
          md="8"
        >
          <v-text-field
            v-model="nombrePresentante"
            :rules="nameRules"
            
            label="D./Dña. Sr/Sra."
            required
          ></v-text-field>
        </v-col>
        <v-col
          cols="12"
          md="4"
        >
          <v-text-field
            v-model="nifPresentante"
            :rules="nameRules"
            
            label="NIF"
            
          ></v-text-field>
        </v-col>
        
      </v-row>
      <v-row>

        <v-col
          cols="12"
          md="4"
        >
          <v-text-field
            v-model="calidadPresentante"
            
          
            label="en calidad de / en qualitat de"
            
          ></v-text-field>
          
        </v-col>
        <v-col
          cols="12"
          md="8"
          >
          <div>
          (presentante, administrador,secretario del consejo de administración)
          </div>
          <div>
          (presentador, administrador,secretari del consell d'administració)
          </div>
        </v-col>
        </v-row>

        <v-row>
          <v-col
          cols="12"
          md="4"
        >
          <v-text-field
            v-model="telefonoPresentante"
            label="teléfono / telèfon"
            
          ></v-text-field>
        </v-col>
      
        <v-col
          cols="12"
          md="8"
        >
          <v-text-field
            v-model="emailPresentante"
            :rules="emailRules"
            label="Correo electrónico / Correu electrònic"
            required
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="text-right">

    
    <v-btn
      color="error"
    
      
      @click="limpiarPresentante"
    >
      Vaciar campos / Buidar camps
    </v-btn>
    </v-col>  
      </v-row>
      </div>
      <div style="border: solid;margin: 10px;padding: 30px">
        <v-row
          cols="12"
          md="12">
          EXPONE:<br/>
          EXPOSA:<br/>
          Que para cumplir con lo establecido en la Orden de Justicia 794/2021, adjunto se aporta la declaración covid correspondiente a las cuentas anuales previamente presentadas del ejercicio 2020 de la siguiente sociedad:<br/><br/>
          Que per a complir amb l'establert en l'Ordre de Justícia 794/2021, adjunt s'aporta la declaració covid corresponent als comptes anuals previament presentats de l'exercici 2020 de la següent societat:
        </v-row>
        <v-row>
          <v-col>
            <v-text-field
            v-model="denominacionSociedad"
            :rules="nameRules"
            label="Denominación social/Denominació social"></v-text-field>
          </v-col>
        </v-row>
        
        <v-row>
          <v-col cols="12" md="2">
            <v-text-field
            v-model="nifSociedad"
            :rules="nameRules"
            label="NIF">

            </v-text-field>
          </v-col>
         
          <v-col cols="12" md="4">
            <v-select
              v-model="ano"
              label="Año / Any"
              hint="año de presentación del depósito en el Registro /  any de presentació del dipòsit en el Registre"
              :items="anos"
              persistent-hint
              >
            </v-select>

          </v-col>
          
          <v-col
        cols="12"
        md="2">
        <v-text-field
        v-model="canalSociedad"
        :rules="canalRules"
        label="Canal"
        required>
        
        </v-text-field>
        </v-col>

        
          <v-col cols="12" md="4">
            <v-text-field
            v-model="entradaSociedad"
            :rules="entradaRules"
            label="Número de entrada / Número d'entrada">

            </v-text-field>
          </v-col>
          
        </v-row>

        
      

     
      <v-row>
          <v-file-input
    accept=".pdf"
    label="Elegir el pdf de la hoja COVID / Triar el pdf del full COVID"
    type="file"
    v-model="files"
    :rules="fileRules"
  
    truncate-length="100"
    
  ></v-file-input >
      </v-row>
      
      <v-row>
        <v-col >
          <v-btn
      :disabled="!valid"
      color="success"
      @click="validate"
    >
      Enviar
    </v-btn>
    </v-col>
  
    <v-col class="text-right">

    
    <v-btn
      color="error"
    
      
      @click="limpiarSociedad"
    >
      Vaciar campos / Buidar camps
    </v-btn>
    </v-col>  
      

    <!--v-btn
      color="warning"
      @click="resetValidation"
    >
      Reset Validation
    </v-btn-->
      </v-row>
      </div>
      <div v-if="presentacionOK" style="border: 5px solid;border-color: green; margin: 10px;padding: 30px">
        <v-row>
        Recibida aportación de la hoja covid-19, se procede a incorporarla a las cuentas anuales presentadas previamente y relacionadas en la instancia de remisión.
        <br/><br/>    
        SOCIEDAD: {{denominacionSociedad}}<br/>
        CANAL: {{canalSociedad}}<br/>
        Nº DE ENTRADA: {{entradaSociedad}}<br/>
        Referencia envio : {{uuid}}<br/>
        Fecha envio : {{fechaEnvio}}<br/><br/>
        
        <v-divider inset></v-divider>
        <br/>
        Rebuda aportació del full covid-19, es procedeix a incorporar-ho als comptes anuals presentats prèviament i relacionats en la instància de remissió.
        <br/><br/>    
        SOCIETAT: {{denominacionSociedad}}<br/>
        CANAL: {{canalSociedad}}<br/>
        Núm D'ENTRADA: {{entradaSociedad}}<br/>
        Referència enviament : {{uuid}}<br/>
        Data d'enviament : {{fechaEnvio}}<br/><br/>
        
  </v-row>
      </div>
      <div v-if="presentacionKO" style="border: 5px solid;border-color: red; margin: 10px;padding: 30px">
        <v-row>
       No se ha podido anexar la hoja covid a las cuentas anuales presentadas al haberse producido un error. Por favor vuelva a intentarlo.<br/><br/>
       Datos indicados en su instancia:<br/><br/>
       SOCIEDAD: {{denominacionSociedad}}<br/>
       NIF SOCIEDAD: {{nifSociedad}}<br/>
       CANAL: {{canalSociedad}}<br/>
       Nº DE ENTRADA: {{entradaSociedad}}<br/><br/>
       Datos del error : {{texteError}}<br/><br/>
       Si desea realizar alguna consulta al respecto póngase en contacto con el Registro Mercantil de Barcelona.<br/>
        Telfs: 93.508.14.42 / 93.508.14.43 / 93.508.14.44<br/>
        infocuentas@registromercantilbcn.es / cuentas2@registromercantilbcn.es<br/><br/>
        <v-divider inset></v-divider>
        <br/>
        No s'ha pogut annexar el full covid  als comptes anuals presentats a l'haver-se produït un error. Si us plau  torni a intentar-ho.<br/><br/>
        Dades indicades a la seva instància:<br/><br/>
        SOCIETAT: {{denominacionSociedad}}<br/>
        NIF SOCIETAT: {{nifSociedad}}<br/>
        CANAL: {{canalSociedad}}<br/>
        Núm D'ENTRADA: {{entradaSociedad}}<br/><br/>
        Dades de l'error : {{texteError}}<br/><br/>
         Si desitja realitzar alguna consulta al respecte posi's en contacte amb el Registre Mercantil de Barcelona.<br/>
        Telfs: 93.508.14.42 / 93.508.14.43 / 93.508.14.44<br/>
        infocuentas@registromercantilbcn.es / cuentas2@registromercantilbcn.es<br/>

        </v-row>
        </div>
      <div style="border: 1px solid;margin: 10px;padding: 30px">
        <v-row>
          <v-col cols="12" md="5">
            <span style="font-size: 12px">
            Presentaciones telemáticas indicar 99 para el canal y seis últimas cifras para el número de entrada<br/>
            Presentacions telemàtiques indiqueu 99 pel canal i les sis últimes xifres pel número d'entrada<br/>
            </span>
            <br/>
            Ej / ex : 2020/2/9941123045 --> canal 99 entrada 123045
            <br/>
            
          </v-col>
          <v-col cols="12" md="2"></v-col>
          <v-col cols="12" md="5">
            <span style="font-size: 12px">
            Presentacion de ventanilla<br/><br/>
            Presentació de finestreta<br/><br/>
            <br/>
            </span>
            Ej /ex: 2-121 --> canal 2 entrada 121
            <br/>
          </v-col>
          <v-col>
            <span style="font-size: 12px">
            El número de entrada de las cuentas presentadas telemáticamente está en el acuse de recibo y en presentaciones de ventanilla en el resguardo.<br/>
            El número d'entrada dels comptes presentats telemàticament es troba al justificant de recepció i en presentacions de finestreta al resguard.
            </span>
          </v-col>
        </v-row>
      
      </div>
      <div style="border: 1px;margin: 10px;padding: 30px;font-size: 10px">
A los efectos de la Ley Orgánica 15/1999 de 13 de diciembre, de Protección de Datos de carácter personal, queda informado de los siguientes:
1. Los datos personales expresados en el presente documento serán incorporados al fichero del Registro y a los ficheros relacionados con este, cuyo responsable último es el Registrador. Su uso y fin será el previsto expresamente en la normativa registral. La información en ellos contenida solo será comunicada en los supuestos previstos legalmente, o con objeto de satisfacer las solicitudes de publicidad formal que se formulen de acuerdo con la legislación registral (arts. 2,4,9 y 12 del Título preliminar del RRM e Instrucciones del 29 de octubre de 1996 y 17 de febrero de 1998).
2. En cuanto resulte compatible con la legislación específica del Registro, se reconoce a los interesados los derechos de acceso, rectificación cancelación y oposición, establecidos en la Ley Orgánica citada, pudiendo ejercitarlos dirigiendo un escrito a la dirección del Registro.
3. La obtención y tratamiento de sus datos en la forma indicada es condición necesaria para la prestación de estos servicios.
<br/><br/>
        Als efectes de la Llei Orgànica 15/1999 de 13 de desembre, de Protecció de Dades de caràcter personal, queda informat del següent:
1. Les dades personals expressades en el present document seran incorporades al fitxer del Registre i als fitxers relacionats amb aquest, el responsable últim del qual és el Registrador. El seu ús i fi serà el previst expressament en la normativa registral. La informació en ells continguda solament serà comunicada en els supòsits prevists legalment, o a fi de satisfer les sol·licituds de publicitat formal que es formulin d'acord amb la legislació registral (arts. 2,4,9 i 12 del Títol preliminar del RRM i Instruccions del 29 d'octubre de 1996 i 17 de febrer de 1998).
2. Quan resulti compatible amb la legislació específica del Registre, es reconeix als interessats els drets d'accés, rectificació cancel·lació i oposició, establerts en la Llei Orgànica citada,

      </div>
    </v-container>
  </v-form>
</template>
<script>
  import axios from 'axios'
  import https from 'https'

  export default {
    data: () => ({
      //server: 'https://hcovid.mywire.org:443',
      server: 'https://hcovid.registromercantilbcn.es:443',
      versio: 1.11,
      valid: false,
      presentacionOK: false,
      presentacionKO : false,
      firstname: 'a',
      lastname: 'a',
      nombrePresentante:'',
      nifPresentante: '',
      calidadPresentante: '',
      telefonoPresentante: '',
      emailPresentante: '',
      denominacionSociedad: '',
      nifSociedad: '',
      canalSociedad: '',
      entradaSociedad: '',
      uuid: '',
      texteError: '',
      ano: 0,
      anos: [],
      nameRules: [
        v => !!v || 'Campo alfanumerico requerido / Camp alfanumeric necessari',
        v => v.length > 2 || 'el Campo debe ser mayor de 2 caracteres / el camp ha de ser mes gran de 2 caracters',
      ],
      email: 'a@b',
      emailRules: [
        v => !!v || 'E-mail',
        v => /.+@.+/.test(v) || 'E-mail debe ser válido / E-mail invalid',
      ],
      canalRules: [
        v => !!v || 'Campo numerico requerido / Camp numeric necessari',
        v => /^\d{1,2}$/.test(v) || 'el canal debe estar compuesto de 1 o 2 digitos / el camp ha de tenir 1 o 2 digits', 
      ],
      entradaRules: [
        v => !!v || 'Campo numerico requerido / Camp numeric necessari',
        v => /^\d{1,6}$/.test(v) || 'la entrada debe estar compuesta de haste 6 digitos / la entrada ha de estar formada per fins a 6 digits', 
      ],
      fileRules: [
        v => !!v || 'debe elegir un fichero / ha de triar un fitxer',
      ],
      
      files: null,
      fechaEnvio: null,
      agent: {}
    }),
    methods: {
      limpiarPresentante(){
        /*this.nombrePresentante = 'nom pres';
        this.nifPresentante = 'A3434344';
        this.calidadPresentante = '';
        this.telefonoPresentante = '';
        this.emailPresentante = 'a@b.com';
        this.limpiarErrores();
        */
       this.nombrePresentante = '';
        this.nifPresentante = '';
        this.calidadPresentante = '';
        this.telefonoPresentante = '';
        this.emailPresentante = '';
        this.limpiarErrores();
      },
      limpiarSociedad(){
        /*this.denominacionSociedad = 'LABANDA SA';
        this.nifSociedad = 'B67164566';
        this.canalSociedad = '99';
        this.entradaSociedad = '122866';
        this.limpiarErrores();
        */
       this.denominacionSociedad = '';
        this.nifSociedad = '';
        this.canalSociedad = '';
        this.entradaSociedad = '';
        this.files = null;
        this.fechaEnvio = null;
        this.limpiarErrores();
        this.resetValidation();
      },
      limpiarErrores(){
        this.presentacionOK = false;
        this.presentacionKO = false;
        this.texteError = '';
      },
      guardarDatosPresentante(){
        localStorage.presentante = {'nombrePresentante': this.nombrePresentante,'nifPresentante': this.nifPresentante,'calidadPresentante': this.calidadPresentante,'telefonoPresentante': this.telefonoPresentante,'emailPresentante': this.emailPresentante}

      },
      recuperarDatosPresentante(){
        if (localStorage.presentante){
          this.nombrePresentante = localStorage.presentante.nombrePresentante;
          this.nifPresentante = localStorage.presentante.nifPresentante;
          this.calidadPresentante = localStorage.presentante.calidadPresentante;
          this.telefonoPresentante = localStorage.presentante.telefonoPresentante;
          this.emailPresentante = localStorage.presentante.emailPresentante;
        }
      },
        validate () {
          this.limpiarErrores();
          this.$refs.form.validate();
          if (this.valid) {
            this.guardarDatosPresentante();
            this.submitData();
          }

      },
      reset () {
        this.$refs.form.reset()
      },
      resetValidation () {
        this.$refs.form.resetValidation()
      },
      async submitData(){
        /*
        let formData = new FormData();
        formData.append('versio',this.versio);
        formData.append('canal',this.canalSociedad);
        formData.append('entrada',this.entradaSociedad);
        formData.append('nif',this.nifSociedad);
        */
       let data = {'versio': this.versio,'canal': this.canalSociedad,'entrada': this.entradaSociedad,'nif': this.nifSociedad};
       data.entrada = (parseInt(data.entrada) + (this.ano - 2021 + 41)*1000000).toString();
       console.log('entrada : ',data.entrada); 
        try{
          let resultat;
          if (this.agent)
            resultat = await axios.post(`${this.server}/buscaDiposit`,{ data, httpsAgent: this.agent});//,{ headers: {'Content-Type': 'multipart/form-data'}});
          else
             resultat = await axios.post(`${this.server}/buscaDiposit`,{ data});
          if (resultat.data.err === 0){
            if (resultat.data.uuid){
              if (!this.files){
                console.log('fichero no adjuntado');
                return;
              }
              else {
                console.log('uuid ',resultat.data.uuid);
                console.log('files : ',this.files,'files.name : ',this.files.name);
                let formData = new FormData();
                let aux_uuid = resultat.data.uuid;
                formData.append('uuid',aux_uuid);
                this.uuid = aux_uuid;
               // for (let file of this.files) {
               //   formData.append("files", file, file.name);
                  
               // }

                
                formData.append('fitxer',this.files,this.files.name);
                formData.append('nombrePresentante', this.nombrePresentante);
                formData.append('nifPresentante',this.nifPresentante);
                formData.append('calidadPresentante',this.calidadPresentante);
                formData.append('telefonoPResentante',this.telefonoPresentante);
                formData.append('emailPresentante',this.emailPresentante);
                formData.append('denominacionSociedad',this.denominacionSociedad);
                console.log('formdata : ',...formData.entries())
                let resultatEnviament;
                if (this.agent)
                  resultatEnviament = await axios.post(`${this.server}/full`, formData , {httpsAgent: this.agent} );//}, { headers: { 'Content-Type': undefined}}); 
                  else 
                  resultatEnviament = await axios.post(`${this.server}/full`, formData  );
                if (resultatEnviament){
                  if (resultatEnviament.data.status){
                    this.presentacionOK = true;
                    this.fechaEnvio = new Date(resultatEnviament.data.fecha);
                  }
                  else {
                    this.missatge(resultatEnviament.data);
                  }

                }
                else {
                  this.missatge('comunicacion perdida , por favor reintente en unos minutos / comunicacio perduda, si us plau provi-ho en uns minuts');
                }
              }
            }
            else {
              this.missatge('comunicacion perdida , por favor reintente en unos minutos / comunicacio perduda, si us plau provi-ho en uns minuts');
            }
          }
          else {
            console.log('passa per resultat !== 0');
            let texte;
            switch (resultat.data.err){
              case -5 : 
                texte = 'Version obsoleta, por favor recarge la pagina / Versio obsoleta, si us plau, recarregui la pàgina';
                break;
              case -2:
                texte = 'error IP, reintente en unos minutos / error IP, provi-ho passats uns minuts';
                break;
              case -4:
                texte = 'Error de sobrecarga, por favor reintente pasados unos minutos / Error de sobrecarrega, si us plau , provi-ho passats uns minuts';
                break;
              case -6:
                texte = 'Error, el canal y entrada deben ser numericos / Error, el canal i la entrada han de ser numerics';
                break;
              case -1:
                texte = 'Error no especificado, por favor reintente pasados unos minutos / Error no especificat , si us plou , provi-ho passats uns minuts';
                break;
              case -11:
                texte = 'No se encuentra ninguna presentación con el canal,entrada y/o NIF especificado / No es troba cap entrada amb el canal , entrada i/o NIF informat';
                break;
              case -12:
                texte = "Ya se había presentado la hoja covid, por lo que este envío se descarta / Ja s'havia presentat el full covid, motiu pel cual aquest enviament queda descartat ";
                break;
              case -13:
                texte = "Se ha producido un error interno en los sistemas del Registro, por favor reintentelo pasados unos minutos / S'ha produït un error intern en els sistemes del Registre, si us plau, provi-ho passats uns minuts";
                break;
              case -14:
                texte = "Solo se admiten entradas correspondientes al ejercicio 2020 y posteriores , si se trata de un error, por favor contactar con el Registro / Nomès d'admeten entrades dels exercicis 2020 i posteriors, si es tracta de una errada , si us play, posis en contacte amb el Registre.";
                break;

              default:
                texte = "Se ha producido un error indeterminado / S'ha produit un error indeterminat";


            }
            this.missatge(texte);
          }

        } catch (e) {this.missatge(e);}
      },
      missatge(data){
        this.texteError = data;
        this.presentacionKO = true;
        console.log(data);
      },
     async  test(){
        let form = new FormData();
        form.append('campo1','valor1');
        form.append('campo2','valor2');
        let resultatEnviament = await axios.post(`${this.server}/test/`, { 'campo1': 'valor1','campo2': 'valor2' }, { headers: { 'Content-Type': undefined}});
        console.log('resultat : ',resultatEnviament);
      },
      imprime(){
        this.$htmlToPaper();
      }

/*
        if(this.files){
            for (const key in this.files) {
                console.log(`${key}: ${this.files[key]}`);
}
           // for  ( let file of this.files) {
                

                
                //let fileReader = new FileReader();
                //fileReader
                //fileReader.readAsText(file);
                let file = this.files;
                console.log('file components');
                for (const key in file) {
                console.log(`${key}: ${file[key]}`);
}
                formData.append("fitxer", file, file.name)
                console.log(JSON.stringify(file));
                
            //}
            
             // additional data
             console.log(this.files);
            formData.append("test", "foo bar");
            console.log(formData.getAll("fitxer"))
            
            axios.post(`${this.server}/full`, 
                        {
                            body: formData,
                        
                        }, 
                        { 
                            headers: { 
                                //'Content-Type': 'multipart/form-data'
                                //'Content-Type': 'application/pdf'
                                'Content-Type': undefined
                                
                                
                            } 
                        }).then( response => {
                            console.log('Success!')
                            console.log({response})
                        }).catch(error => {
                            console.log({error})
                        })
        }
        else {
            console.log('there are no files.')
        }
    }*/
    },
    async mounted(){
      this.recuperarDatosPresentante();
      // hack para funcionamiento local
      this.agent = new https.Agent({ rejectUnauthorized: false })
      axios.get('https://it.rmb.es', {httpsAgent: this.agent}).then(() =>{
        this.server = 'https://srv_gestion2.rmb.es:443';
        console.log('trovat i canviat nom');

      })
      .catch(() => {console.log('no trovat, deixem nom igual');this.agent = null})
     
     this.ano = new Date().getFullYear();
      for (let auxAno = 2021 ; auxAno <= new Date().getFullYear() ; auxAno ++) this.anos.push(auxAno);
      //console.log('ano : ',this.ano,'anos : ',this.anos);
      //this.anos.push(2022);
      //this.resetValidation();
    }
  }
</script>